// Single source of truth for whether the app is running against the mock
// in-memory backend (src/mocks) instead of the real Laravel API.
//
// Defaults to ON: the backend isn't wired up in this environment yet, so a
// demo needs to work standalone. Once the real API is available, set
// VITE_DEMO_MODE=false in frontend/.env and everything routes to axios
// again — no other code changes needed.
export const DEMO_MODE = import.meta.env.VITE_DEMO_MODE !== 'false';
